import { Component } from '@angular/core';
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";
import {NgForOf} from "@angular/common";
declare var bootstrap: any;

@Component({
  selector: 'app-responsabilidad-social',
  standalone: true,
  imports: [
    NavBarComponent,
    FooterPersonaComponent,
    NgForOf
  ],
  templateUrl: './responsabilidad-social.component.html',
  styleUrl: './responsabilidad-social.component.css'
})
export class ResponsabilidadSocialComponent {

  fotosResponsabilitySocial = [
    {"nameImagen": "IMG_0142.JPG"},
    {"nameImagen": "IMG_2611.JPG"},
    {"nameImagen": "IMG_0177.JPG"},
    {"nameImagen": "IMG_2651.JPG"},
    {"nameImagen": "IMG_0560.JPG"},
    {"nameImagen": "IMG_2710.JPG"},
    {"nameImagen": "IMG_2260.JPG"},
    {"nameImagen": "IMG_2799.JPG"},
    {"nameImagen": "IMG_2266.JPG"},
    {"nameImagen": "IMG_2840.JPG"},
    {"nameImagen": "IMG_2361.JPG"},
    {"nameImagen": "IMG_4029.JPG"},
    {"nameImagen": "IMG_2373.JPG"},
    {"nameImagen": "IMG_4136.JPG"},
    {"nameImagen": "IMG_2507.JPG"},
    {"nameImagen": "IMG_4218.JPG"},
    {"nameImagen": "IMG_2522.JPG"},
    {"nameImagen": "IMG_4228.JPG"},
    {"nameImagen": "IMG_2604.JPG"},
    {"nameImagen": "IMG_4251.JPG"}
  ]


  selectedImage: string | null = null;

  openModal(imageName: string) {
    this.selectedImage = imageName;
    const modalElement = document.getElementById('imageModal') as HTMLElement;
    const bootstrapModal = new bootstrap.Modal(modalElement);
    bootstrapModal.show();
  }

}
